// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1FzSv","footer":"ChangeClinic_footer__2UQN2"};